// import { useEffect, useRef, useState } from "react";
// import TextareaAutosize from "react-textarea-autosize";
// import EmojiPicker from "emoji-picker-react";
// import { useAssistant } from "@utils/GemniConnection";
// import { toast } from "react-toastify";
// import Robot from "@assets/images/Robot.svg";
// import { useTranslation } from "react-i18next";
// import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader";
// import { getChatHistory, saveChat } from "api/fitbot";
// const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

// const FitBotChat = () => {
//   const [messages, setMessages] = useState([]);
//   const { t } = useTranslation();
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [isStreaming, setIsStreaming] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [abortController, setAbortController] = useState(null);
//   const bottomRef = useRef(null);
//   const { chatStream } = useAssistant();

//   const initialBotMessage = {
//     sender: "bot",
//     text: t("initialFitBotMessage"),
//   };
//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   const fetchChatHistory = async () => {
//     try {
//       const data = await getChatHistory();

//       if (data.length > 0) {
//         const formattedMessages = data.flatMap((chat) =>
//           chat?.messages?.map((msg) => ({
//             sender: msg?.sender,
//             text: msg?.text,
//             image: msg?.image || null,
//           }))
//         );
//         setMessages([initialBotMessage, ...formattedMessages]);
//       } else {
//         setMessages([initialBotMessage]);
//       }
//     } catch (error) {
//       console.error("Error fetching chat history:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchChatHistory();
//   }, []);

//   const handleSend = async () => {
//     const controller = new AbortController();
//     setAbortController(controller);

//     if (!message.trim() && !selectedImage) return;

//     // Save user message
//     const userMessage = { sender: "user", text: message, image: imagePreview };
//     setMessages((prev) => [...prev, userMessage]);

//     try {
//       let imagePart = null;
//       let imageForBackend = selectedImage;

//       if (selectedImage) {
//         // Convert the File directly to base64
//         const base64Image = await fileToBase64(selectedImage);
//         imagePart = {
//           inlineData: {
//             data: base64Image,
//             mimeType: selectedImage.type,
//           },
//         };
//       }

//       const parts = [];
//       if (message.trim()) parts.push({ text: message });
//       if (imagePart) parts.push(imagePart);

//       // Add empty bot message placeholder for streaming
//       setMessages((prev) => [...prev, { text: "", sender: "bot" }]);

//       // Clear input fields
//       setMessage("");
//       setSelectedImage(null);
//       setImagePreview(null);
//       setLoading(true);

//       setIsStreaming(true);
//       let fullResponse = "";

//       for await (const chunk of chatStream(parts, controller.signal)) {
//         if (controller.signal.aborted) {
//           break;
//         }
//         if (chunk) {
//           fullResponse += chunk;
//           setMessages((prev) => {
//             const lastIndex = prev.length - 1;
//             const lastMsg = prev[lastIndex];
//             if (
//               lastMsg.sender === "bot" &&
//               lastMsg.text.length <= fullResponse.length
//             ) {
//               return [
//                 ...prev.slice(0, lastIndex),
//                 { ...lastMsg, text: fullResponse },
//               ];
//             }
//             return prev;
//           });
//         }
//       }

//       // After streaming is complete, store the conversation
//       if (fullResponse) {
//         const chatMessages = [
//           { sender: "user", text: message },
//           { sender: "bot", text: fullResponse },
//         ];
//         await saveChat(chatMessages, imageForBackend);
//       }
//     } catch (error) {
//       if (error.name !== "AbortError") {
//         console.error("FitBot error:", error);
//         setMessages((prev) => [
//           ...prev,
//           {
//             sender: "bot",
//             text: "Oops! Something went wrong. Try again later.",
//           },
//         ]);
//       }
//     } finally {
//       if (!controller.signal.aborted) {
//         setLoading(false);
//         setIsStreaming(false);
//         setAbortController(null);
//       }
//     }
//   };

//   // Replace blobToBase64 with fileToBase64
//   const fileToBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => {
//         // Remove the data:image/...;base64, prefix
//         const base64 = reader.result.split(",")[1];
//         resolve(base64);
//       };
//       reader.onerror = reject;
//       reader.readAsDataURL(file);
//     });
//   };

//   const handleImageUpload = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     if (!file.type.startsWith("image/")) {
//       toast.error(t("Only image files are allowed."));
//       return;
//     }
//     const validExtensions = ["jpg", "jpeg", "png", "webp", "gif",
//       // "svg"
//     ];
//     const fileExtension = file.name.split(".").pop().toLowerCase();
//     if (!validExtensions.includes(fileExtension)) {
//       toast.error(t("Please upload a valid image format"));
//       return;
//     }

//     setSelectedImage(file);
//     setImagePreview(URL.createObjectURL(file));
//   };

//   const handleExportChat = () => {
//     const chatText = messages
//       .map((msg) => `${msg.sender === "bot" ? "FitBot" : "You"}: ${msg.text}`)
//       .join("\n");
//     const blob = new Blob([chatText], { type: "text/plain" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "chat.txt";
//     a.click();
//   };

//   const onEmojiClick = (emojiData) => {
//     setMessage((prev) => prev + emojiData.emoji);
//     setShowEmojiPicker(false);
//   };
//   const handleStop = () => {
//     if (abortController) {
//       abortController.abort();
//       setLoading(false);
//       setIsStreaming(false);
//       setAbortController(null);
//       setMessages((prev) => {
//         const lastIndex = prev.length - 1;
//         if (prev[lastIndex]?.sender === "bot" && prev[lastIndex]?.text === "") {
//           return prev.slice(0, -1);
//         }
//         return prev;
//       });
//     }
//   };
//   return (
//     <div className={`h-[100%] max-h-[100%]`}>
//       {isLoading ? (
//         <ActualDietPlanLoader fitbot={true} />
//       ) : (
//         <div
//           id="chatgpt-chatbox"
//           className="rounded-lg shadow-lg w-full bg-white  rounded-t-[16px] bg-cover h-[100%]"
//         >
//           <div
//             className="bg-cover md:bg-cover p-4 relative text-white h-[28%] md:h-[20%] max-h-[212px] rounded-t-[16px]"
//             style={{
//               backgroundImage: "url('/Fitbot_New_BG.png')",
//               backgroundRepeat: "no-repeat",
//               backgroundPosition:"bottom"
//             }}
//           >
//             <h1 className="font-[700] font-[Lato] text-[24px]">
//               {t("FitBot Assistant")}
//             </h1>
//             <p className="font-[400] font-[Open Sans] text-[16px]">
//               {t("fitBotSubheading")}
//             </p>
//           </div>

//           <div className="overflow-auto h-[52%] md:h-[60%] p-4 md:py-4 xl:px-[40px] bg-gray-50">
//             {messages.map((msg, index) => {
//               return (
//                 <div
//                   key={index}
//                   className={`mb-4 p-3 rounded-[13px]  w-[fit-content] max-w-[85%] break-words ${
//                     msg.sender === "user"
//                       ? "ml-auto bg-white border text-[#707070]"
//                       : "mr-auto bg-white"
//                   }`}
//                 >
//                   {msg.sender === "bot" ? (
//                     <>
//                       <div className="flex mb-1 gap-2">
//                         <div className="hidden md:block min-w-12 min-h-12 max-w-12 max-h-12  bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] p-2 rounded-full flex items-center justify-center">
//                           <img
//                             src={Robot}
//                             alt="FitBot Icon"
//                             className="w-full h-full object-contain"
//                           />
//                         </div>

//                         <div>
//                           <div className=" bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] p-5 rounded-[13px] rounded-tl-0 text-white text-[18px] font-[Lato] font-[400]">
//                             {loading &&
//                             index === messages?.length - 1 &&
//                             !msg.text ? (
//                               <div className="text-white italic">
//                                 {t("Just a sec")}...
//                               </div>
//                             ) : (
//                               msg.text.split("\n").map((line, i) => (
//                                 <div key={i} className="whitespace-pre-line">
//                                   {line}
//                                 </div>
//                               ))
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     <div>
//                       {msg?.image && (
//                         <div className="mb-2">
//                           <img
//                             src={
//                               msg?.image?.startsWith("blob:")
//                                 ? msg?.image
//                                 : `${BASE_URL.replace(/\/$/, "")}${msg.image}`
//                             }
//                             alt="User uploaded"
//                             className="max-w-full h-auto rounded-md border"
//                           />
//                         </div>
//                       )}
//                       {msg.text.split("\n").map((line, i) => (
//                         <div key={i} className="whitespace-pre-line text-[18px]">
//                           {line}
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   <div ref={bottomRef} />
//                 </div>
//               );
//             })}
//           </div>

//           <div className="p-4 md:py-4 md:px-[40px] bg-white h-[20%] flex flex-col justify-end">
//             {imagePreview && (
//               <div className="mb-3 relative w-full flex justify-end">
//                 <div className="relative group">
//                   <div className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] p-1 rounded-[13px] rounded-tr-0 inline-block">
//                     <img
//                       src={imagePreview}
//                       alt="Preview"
//                       className="max-w-[200px] max-h-[200px] rounded-[10px] border-2 border-white object-cover shadow-sm"
//                     />
//                   </div>
//                   <button
//                     onClick={() => {
//                       setSelectedImage(null);
//                       setImagePreview(null);
//                     }}
//                     className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-600 transition-colors duration-200"
//                   >
//                     ✕
//                   </button>
//                 </div>
//               </div>
//             )}
//             <div className="relative flex items-center gap-1 md:gap-2 border rounded-[16px] py-2 px-1 md:px-4 bg-white">
//               <div className="relative">
//                 <button
//                   onClick={() => setShowEmojiPicker(!showEmojiPicker)}
//                   className="p-2 hover:bg-gray-100 rounded-lg"
//                   disabled={isStreaming}
//                 >
//                   <img src="/Emoji.png" alt="Emoji Icon" className="w-6 h-6" />
//                 </button>

//                 {showEmojiPicker && (
//                   <div className="absolute bottom-12 left-0 z-50">
//                     <EmojiPicker
//                       onEmojiClick={onEmojiClick}
//                       disabled={isStreaming}
//                     />
//                   </div>
//                 )}
//               </div>

//               <TextareaAutosize
//                 placeholder={`${t("Send a message")}...`}
//                 className="flex-1 border-none rounded-xl p-1 md:p-3 text-[16px] font-[Lato] resize-none focus:outline-none  overflow-y-auto"
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                 maxRows={4}
//                 // minRows={4}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" && !e.shiftKey && !isStreaming) {
//                     e.preventDefault();
//                     handleSend();
//                   }
//                 }}
//               />

//               <input
//                 type="file"
//                 id="file-upload"
//                 hidden
//                 accept="image/*"
//                 onChange={handleImageUpload}
//                 disabled={isStreaming}
//               />

//               <button
//                 onClick={handleExportChat}
//                 disabled={isStreaming}
//                 className="hover:bg-blue-100 rounded-full"
//               >
//                 <svg
//                   width="26"
//                   height="26"
//                   viewBox="0 0 26 26"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <g opacity="0.4">
//                     <path
//                       d="M5.9094 23.4693L5.16406 22.6958L8.90156 18.9583H5.67106V17.875H10.7291V22.9342H9.64581V19.7307L5.9094 23.4693ZM13.314 22.75V21.6667H18.8346C19.0289 21.6667 19.1885 21.6042 19.3135 21.4792C19.4384 21.3543 19.5009 21.1947 19.5009 21.0004V8.66667H15.1676V4.33333H7.16823C6.97323 4.33333 6.81326 4.39581 6.68831 4.52075C6.56337 4.64569 6.5009 4.80567 6.5009 5.00067V15.2923H5.41756V5.00067C5.41756 4.51533 5.58801 4.10222 5.9289 3.76133C6.26979 3.42044 6.6829 3.25 7.16823 3.25H15.7092L20.5842 8.125V21.0004C20.5842 21.4843 20.4138 21.8971 20.0729 22.2387C19.732 22.5796 19.3193 22.75 18.8346 22.75H13.314Z"
//                       fill="black"
//                     />
//                   </g>
//                 </svg>
//               </button>

//               <button
//                 onClick={() => document.getElementById("file-upload").click()}
//                 className=" hover:bg-gray-100 rounded-lg"
//               >
//                 <img
//                   src="/Attachment.png"
//                   alt="File Icon"
//                   className="w-6 h-6"
//                 />
//               </button>

//               {isStreaming ? (
//                 <button
//                   onClick={handleStop}
//                   className="hover:bg-red-100 rounded-full"
//                 >
//                   <svg
//                     width="40"
//                     height="40"
//                     viewBox="0 0 40 40"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <rect width="40" height="40" rx="20" fill="#E60505" />
//                     <rect x="14" y="14" width="12" height="12" fill="white" />
//                   </svg>
//                 </button>
//               ) : (
//                 <button
//                   id="send-chat"
//                   onClick={handleSend}
//                   className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full p-2"
//                 >
//                   <svg
//                     width="25"
//                     height="25"
//                     viewBox="0 0 25 25"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M23.8848 0.754404C21.1209 -2.22214 0.330497 5.06937 0.347667 7.73149C0.367133 10.7503 8.46688 11.679 10.7119 12.3089C12.062 12.6876 12.4235 13.0759 12.7348 14.4916C14.1447 20.9032 14.8525 24.0922 16.4658 24.1634C19.0373 24.2771 26.5822 3.65925 23.8848 0.754404Z"
//                       fill="white"
//                     />
//                     <path
//                       d="M11.7656 12.7423L16.2072 8.30078L11.7656 12.7423Z"
//                       fill="white"
//                     />
//                     <path
//                       d="M11.7656 12.7423L16.2072 8.30078"
//                       stroke="#30A5F9"
//                       stroke-width="2.47635"
//                       stroke-linecap="round"
//                       stroke-linejoin="round"
//                     />
//                   </svg>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FitBotChat;

import { useEffect, useRef, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";
import EmojiPicker from "emoji-picker-react";
import { toast } from "react-toastify";
import { Robot, FitBotSend } from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader";
import { getChatHistory, fiBotChat } from "api/fitbot";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const FitBotChat = () => {
  const [messages, setMessages] = useState([]);
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const bottomRef = useRef(null);

  const initialBotMessage = {
    sender: "bot",
    text: t("initialFitBotMessage"),
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const fetchChatHistory = async () => {
    try {
      const data = await getChatHistory();

      if (data.length > 0) {
        const formattedMessages = data.flatMap((chat) =>
          chat?.messages?.map((msg) => ({
            sender: msg?.sender,
            text: msg?.text,
            image: Array.isArray(msg?.image)
              ? msg.image[0] || null
              : msg?.image || null,
          })),
        );
        setMessages([initialBotMessage, ...formattedMessages]);
      } else {
        setMessages([initialBotMessage]);
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchChatHistory();
  }, []);

  const handleSend = async () => {
    if (!message.trim() && !selectedImage) return;

    const userMessage = { sender: "user", text: message, image: imagePreview };
    setMessages((prev) => [...prev, userMessage]);

    setMessages((prev) => [
      ...prev,
      { text: "...", sender: "bot", isLoading: true },
    ]);

    const userMessageText = message;
    const userImageFile = selectedImage;
    setMessage("");
    setSelectedImage(null);
    setImagePreview(null);
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("message", userMessageText);

      if (userImageFile) {
        formData.append("image", userImageFile);
      }

      const response = await fiBotChat(formData);
      const data = response?.data;
      setMessages((prev) => {
        const newMessages = prev.slice(0, -1);
        return [
          ...newMessages,
          {
            sender: data.sender || "bot",
            text: data.text || "",
            isLoading: false,
          },
        ];
      });
    } catch (error) {
      console.error("FitBot error:", error);

      setMessages((prev) => {
        const newMessages = prev.slice(0, -1);
        return [
          ...newMessages,
          {
            sender: "bot",
            text:
              error.response?.data?.message ||
              "Oops! Something went wrong. Try again later.",
            isLoading: false,
          },
        ];
      });
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast.error(t("Only image files are allowed."));
      return;
    }

    const validExtensions = ["jpg", "jpeg", "png", "webp", "gif"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      toast.error(t("Please upload a valid image format"));
      return;
    }

    setSelectedImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleExportChat = () => {
    const chatText = messages
      .filter((msg) => !msg.isLoading)
      .map((msg) => `${msg.sender === "bot" ? "FitBot" : "You"}: ${msg.text}`)
      .join("\n");
    const blob = new Blob([chatText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "chat.txt";
    a.click();
  };

  const onEmojiClick = (emojiData) => {
    setMessage((prev) => prev + emojiData.emoji);
    setShowEmojiPicker(false);
  };

  return (
    <div className={`h-[100%] max-h-[100%]`}>
      {isLoading ? (
        <ActualDietPlanLoader fitbot={true} />
      ) : (
        <div
          id="chatgpt-chatbox"
          className="rounded-lg shadow-lg w-full bg-white rounded-t-[16px] bg-cover h-[100%]"
        >
          <div
            className="bg-cover md:bg-cover p-4 relative text-white h-[28%] md:h-[20%] max-h-[212px] rounded-t-[16px]"
            style={{
              backgroundImage: "url('/Fitbot_New_BG.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "bottom",
            }}
          >
            <h1 className="font-[700] font-[Lato] text-[24px]">
              {t("FitBot Assistant")}
            </h1>
            <p className="font-[400] font-[Open Sans] text-[16px]">
              {t("fitBotSubheading")}
            </p>
          </div>

          <div className="overflow-auto h-[52%] md:h-[60%] p-4 md:py-4 xl:px-[40px] bg-gray-50">
            {messages.map((msg, index) => {
              return (
                <div
                  key={index}
                  className={`mb-4 p-3 rounded-[13px] w-[fit-content] max-w-[85%] break-words ${
                    msg.sender === "user"
                      ? "ml-auto bg-white border text-[#707070]"
                      : "mr-auto bg-white"
                  }`}
                >
                  {msg.sender === "bot" ? (
                    <>
                      <div className="flex mb-1 gap-2">
                        <div className="hidden md:block min-w-12 min-h-12 max-w-12 max-h-12 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] p-2 rounded-full flex items-center justify-center">
                          <img
                            src={Robot}
                            alt="FitBot Icon"
                            className="w-full h-full object-contain"
                          />
                        </div>

                        <div>
                          <div className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] p-5 rounded-[13px] rounded-tl-0 text-white text-[18px] font-[Lato] font-[400]">
                            {msg.isLoading ? (
                              <div className="text-white italic">
                                {t("Thinking")}...
                              </div>
                            ) : (
                              msg?.text?.split("\n").map((line, i) => (
                                <div key={i} className="whitespace-pre-line">
                                  {line}
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div>
                      {msg?.image && (
                        <div className="mb-2">
                          <img
                            src={msg?.image ? msg?.image : ""}
                            alt="User uploaded"
                            className="max-w-[200px] h-auto rounded-md border object-cover"
                          />
                        </div>
                      )}
                      {msg.text.split("\n").map((line, i) => (
                        <div
                          key={i}
                          className="whitespace-pre-line text-[18px]"
                        >
                          {line}
                        </div>
                      ))}
                    </div>
                  )}

                  <div ref={bottomRef} />
                </div>
              );
            })}
          </div>

          <div className="p-4 md:py-4 md:px-[40px] bg-white h-[20%] flex flex-col justify-end">
            {imagePreview && (
              <div className="mb-3 relative w-full flex justify-end">
                <div className="relative group">
                  <div className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] p-1 rounded-[13px] rounded-tr-0 inline-block">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="max-w-[200px] max-h-[200px] rounded-[10px] border-2 border-white object-cover shadow-sm"
                    />
                  </div>
                  <button
                    onClick={() => {
                      setSelectedImage(null);
                      setImagePreview(null);
                    }}
                    className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-600 transition-colors duration-200"
                  >
                    ✕
                  </button>
                </div>
              </div>
            )}
            <div className="relative flex items-center gap-1 md:gap-2 border rounded-[16px] py-2 px-1 md:px-4 bg-white">
              <div className="relative">
                <button
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                  className="p-2 hover:bg-gray-100 rounded-lg"
                  disabled={loading}
                >
                  <img src="/Emoji.png" alt="Emoji Icon" className="w-6 h-6" />
                </button>

                {showEmojiPicker && (
                  <div className="absolute bottom-12 left-0 z-50">
                    <EmojiPicker
                      onEmojiClick={onEmojiClick}
                      disabled={loading}
                    />
                  </div>
                )}
              </div>

              <TextareaAutosize
                placeholder={`${t("Send a message")}...`}
                className="flex-1 border-none rounded-xl p-1 md:p-3 text-[16px] font-[Lato] resize-none focus:outline-none overflow-y-auto"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                maxRows={4}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey && !loading) {
                    e.preventDefault();
                    handleSend();
                  }
                }}
                disabled={loading}
              />

              <input
                type="file"
                id="file-upload"
                hidden
                accept="image/*"
                onChange={handleImageUpload}
                disabled={loading}
              />

              <button
                onClick={handleExportChat}
                disabled={loading}
                className="hover:bg-blue-100 rounded-full"
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.4">
                    <path
                      d="M5.9094 23.4693L5.16406 22.6958L8.90156 18.9583H5.67106V17.875H10.7291V22.9342H9.64581V19.7307L5.9094 23.4693ZM13.314 22.75V21.6667H18.8346C19.0289 21.6667 19.1885 21.6042 19.3135 21.4792C19.4384 21.3543 19.5009 21.1947 19.5009 21.0004V8.66667H15.1676V4.33333H7.16823C6.97323 4.33333 6.81326 4.39581 6.68831 4.52075C6.56337 4.64569 6.5009 4.80567 6.5009 5.00067V15.2923H5.41756V5.00067C5.41756 4.51533 5.58801 4.10222 5.9289 3.76133C6.26979 3.42044 6.6829 3.25 7.16823 3.25H15.7092L20.5842 8.125V21.0004C20.5842 21.4843 20.4138 21.8971 20.0729 22.2387C19.732 22.5796 19.3193 22.75 18.8346 22.75H13.314Z"
                      fill="black"
                    />
                  </g>
                </svg>
              </button>

              <button
                onClick={() => document.getElementById("file-upload").click()}
                className="hover:bg-gray-100 rounded-lg"
                disabled={loading}
              >
                <img
                  src="/Attachment.png"
                  alt="File Icon"
                  className="w-6 h-6"
                />
              </button>

              <button
                id="send-chat"
                onClick={handleSend}
                disabled={loading || (!message.trim() && !selectedImage)}
                className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-full p-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <FitBotSend />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FitBotChat;
